<template>
  <div>
    <div class="wrapper">
      <button v-if="hide" style="margin-left:0px; background: var(--color-background); color: var(--color-info-dark);"
        @click.prevent="openNav()">
        <span class="material-icons-sharp" style="color: var(--color-dark);">arrow_forward</span>
      </button>
      <!-- Sidebar Holder -->
      <transition enter-active-class="animated fadeInLeft faster" leave-active-class="animated fadeOutLeft faster">
        <nav :class="{ 'sidebar-mobile': _isMobile }" class="sidebar" v-if="exibeMenu" id="sidebar" style="z-index:5">

          <div class="sidebar-header">


            <div class="logo">
              <img src="../../assets/img/logo_services.png">
              <!-- <h2>SERVI<span class="danger">CES</span></h2> -->
            </div>
            <div class="close" id="close-btn" @click.prevent="closeNav()">
              <span class="material-icons-sharp" style="color: var(--color-dark);">
                arrow_back
              </span>
            </div>

            <!-- <div class="row">
              <div class="col-4 text-center">
                <img class="foto-menu-aberto" v-if="foto != null" :src="foto" />
                <fa-icon icon="user-circle" style="font-size: 4.8em" v-if="foto == null" />
              </div>

              <div class="col-8" style="padding-left:2px">
                <a href="#" v-if="_isMobile" class="fechar-modal fechar-modal-mobile text-center float-right"
                  @click.prevent="exibeMenu = false">
                  <fa-icon style="color: #FFF" icon="arrow-left" />
                </a>

                <button type="button" @click.prevent="clickPerfil(); exibeMenu = _isMobile ? false : true"
                  class="btn btn-color btn-sm text-left">
                  <fa-icon icon="user" />Olá,
                  <strong>{{ nome }}</strong>.
                </button>
                <button type="button" style="margin-left:25px" class="btn btn-color btn-sm" @click.prevent="closeNav()">
                  &times;
                </button>
                <br />

                <button type="button" style="margin-top:4px" class="btn btn-color btn-sm"
                  @click.prevent="$refs.modalSair.show(); exibeMenu = _isMobile ? false : true">
                  <fa-icon icon="sign-out-alt" />Sair
                </button>

              </div>
            </div> -->
          </div>

          <flMenu :menus="menu" @exibe-menu="eventExibeMenu" />
          <button type="button" style="margin-left: 12rem;" class="btn btn-color btn-sm"
            @click.prevent="$refs.modalSair.show(); exibeMenu = _isMobile ? false : true">
            <fa-icon style="color: var(--color-dark);" icon="sign-out-alt" /><span style="color: var(--color-dark);">Sair</span>
          </button>
          <div id="footer" class="footer" :style="{ 'width': _isMobile ? '21em' : '' }">
            <div id="content" class="content">
              <img id="image" class="image" src="../../assets/img/followair_services.png" />
              <!-- <div class="version">{{ config.versao }} | {{ _getVersao() }}</div> -->
              <div class="iphone-x-bottom"></div>
            </div>
          </div>
        </nav>
      </transition>

      <!-- Page Content Holder -->
      <div class="container-fluid conteudo"
        :class="{ 'conteudo-mobile': _isMobile, 'margin-mobile': (exibeMenu && _isMobile) }" style="padding: 0px">
        <div v-if="_isMobile" class="menu-mobile">
          <div class="iphone-x-top"></div>
          <div class="row">
            <div class="col-12">
              <span @click="exibeMenu = true">
                <fa-icon style="margin-top: -4px" icon="bars"></fa-icon>MENU
              </span>
            </div>
          </div>
        </div>

        <router-view id="conteudo" :style="{ 'margin-top': marginTop }"></router-view>
      </div>
    </div>

    <flModal ref="modalUser" width="40%">
      <template v-slot:header>
        <fa-icon icon="user" />Você
      </template>
      <flUser :perfil="true" :perfis="perfis" ref="user" />
    </flModal>

    <flModal ref="modalSair" @modal-hide="(sair) => sair ? _sair() : ''" :header="false" width="40%">
      <!-- <template v-slot:header>SAIR</template> -->
      <div class="row">
        <div class="col-12 text-center">
          <h3>Deseja sair do sistema?</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <button type="button" @click="$refs.modalSair.hide()" class="btn float-left btn-outline-secondary">
            <fa-icon icon="times" />Fechar
          </button>

          <button type="button" @click="$refs.modalSair.hide(sair = true)" class="btn float-right btn-primary">
            <fa-icon icon="sign-out-alt" />Sair
          </button>
        </div>
      </div>
    </flModal>
  </div>
</template>

<script>
import _ from "lodash";
import flUser from "../adm/usuario/cadastro.vue";
import flModal from "../../components/modal/main.vue";
import flIcon from "../../components/fl-icon/main.vue";
import flMenu from "./menu.vue";

import { mapActions, mapState } from "vuex";
export default {
  components: {
    flUser,
    flModal,
    flIcon,
    flMenu
  },

  data() {
    return {
      versaoAPI: "",
      exibeMenu: false,
      exibeSub: false,
      marginTop: "0px",
      perfis: [],
      hide: false,
      menu: [],
    };
  },

  beforeMount() {
    this.menu.push({
      routerName: "monitoramento",
      class: "",
      privilegio: 1,
      faIcon: ["fa", "satellite-dish"],
      text: "Monitoramento",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: []
    });

    this.menu.push({
      routerName: "processamento",
      class: "",
      privilegio: 37,
      faIcon: ["fa", "microchip"],
      text: "Processamento",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: []
    });

    /*    this.menu.push({
      routerName: "0",
      class: "",
      privilegio: 27,
      faIcon: ["fa", "ticket-alt"],
      text: "Tickets",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: []
    });  */

    this.menu.push({
      routerName: "ticket",
      class: "",
      privilegio: 33,
      faIcon: ["fa", "ticket-alt"],
      text: "Ticket",
      styleIcon:
        "margin-right: 0.4em;width: 1.3em;margin-top:-1px;fill: #FFF !important",
      classIcon: "",
      exibeSub: false,
      submenu: [
        {
          routerName: "ticket",
          class: "",
          privilegio: 34,
          faIcon: ["fa", "ticket-alt"],
          text: "Visão Geral",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        // {
        //   routerName: "designado",
        //   class: "",
        //   privilegio: 34,
        //   faIcon: ["fa", "ticket-alt"],
        //   text: "Tickets Designados",
        //   styleIcon: "margin-right:0.4em",
        //   classIcon: ""
        // },
        {
          routerName: "projeto",
          class: "",
          privilegio: 34,
          faIcon: ["fa", "industry"],
          text: "Projetos",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "tipo-ticket",
          class: "",
          privilegio: 34,
          faIcon: ["fa", "box"],
          text: "Tipo de Ticket",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "status",
          class: "",
          privilegio: 34,
          faIcon: ["fa", "box"],
          text: "Status",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        }
      ]
    });

    this.menu.push({
      routerName: "cliente",
      class: "",
      privilegio: 23,
      faIcon: ["fa", "users"],
      text: "Clientes",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: []
    });

    this.menu.push({
      routerName: "servico",
      class: "",
      privilegio: 25,
      faIcon: ["fa", "server"],
      text: "Serviços",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: []
    });

    this.menu.push({
      routerName: "equipamento",
      class: "",
      privilegio: 24,
      faIcon: ["fa", "hdd"],
      text: "Equipamentos",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: []
    });

    this.menu.push({
      routerName: "servidor-envio",
      class: "",
      privilegio: 14,
      faIcon: ["fa", "globe-americas"],
      text: "Servidores Envio",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: []
    });

    this.menu.push({
      routerName: "followair",
      class: "",
      privilegio: 33,
      faIcon: ["fas", "plane-departure"],
      text: "Followair",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      exibeSub: false,
      submenu: [
        {
          routerName: "fabricantes",
          class: "",
          privilegio: 34,
          faIcon: ["fa", "industry"],
          text: "Fabricantes",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "modelos",
          class: "",
          privilegio: 34,
          faIcon: ["fa", "box"],
          text: "Modelos",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "manutencao",
          class: "",
          privilegio: 35,
          faIcon: ["fa", "screwdriver"],
          text: "Manutenção",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "atualizacoes",
          class: "",
          privilegio: 35,
          faIcon: ["fa", "sync-alt"],
          text: "Atualizações de manuais",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "local",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "compass"],
          text: "Locais",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        }
      ]
    });

    this.menu.push({
      routerName: "servidor-envio",
      class: "",
      privilegio: 14,
      faIcon: ["fa", "cog"],
      text: "Adm. Geral",
      styleIcon: "margin-right:0.4em",
      classIcon: "",
      submenu: [
        {
          routerName: "usuario",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "key"],
          text: "Usuários",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "perfil",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "address-card"],
          text: "Perfis",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "sistema",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "cubes"],
          text: "Sistemas",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "modulo-geral",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "map"],
          text: "Módulos",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "modulo-sistema",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "cubes"],
          text: "Módulos Sistema",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "privilegio",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "star"],
          text: "Privilégios",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        },
        {
          routerName: "notificacao-config",
          class: "",
          privilegio: 0,
          faIcon: ["fa", "bell"],
          text: "Notificações",
          styleIcon: "margin-right:0.4em",
          classIcon: ""
        }
      ],

      exibeSub: false
    });

    this.menu = this.menu.map(item => {
      item.submenu = item.submenu.map(sub => {
        if (this.$route.path.indexOf(sub.routerName) !== -1) {
          item.exibeSub = true;
        }

        return sub;
      });

      return item;
    });
  },

  computed: {
    ...mapState({
      sessao: state => state.sessao.user,
      webSocket: state => state.sessao.webSocket,
      config: state => state.sessao.config
    }),

    foto() {
      if (!_.isNil(this.sessao)) {
        if (this.sessao.foto == null) {
          return null;
        }

        return this.config.baseURL + "/users/" + this.sessao.foto;
      }
      return null;
    },

    nome() {
      return this.sessao.nome.split(" ")[0];
    },

    exibeConteudo() {
      if (this._isMobile) {
        return !this.exibeMenu;
      }
      return true;
    }
  },

  mounted() {
    if (this._isMobile) {
      this.marginTop = "50px";
    } else {
      this.exibeMenu = true;
    }
    document.body.style.background = "#F0F0F0";
  },

  methods: {
    ...mapActions(["setWebSocket", "setSession"]),

    clickPerfil() {
      this.$refs.modalUser.show();

      this.$nextTick(() => {
        this.$refs.user.carregaUserPerfil(this.sessao.id);
      });
    },

    openNav() {
      document.getElementById("sidebar").style.width = "14rem";
      document.getElementById("conteudo").style.marginLeft = "14rem";
      document.getElementById("footer").style.width = "13.4rem";
      document.getElementById("content").style.display = "flex";
      this.hide = false
    },

    closeNav() {
      document.getElementById("sidebar").style.width = "0px";
      document.getElementById("conteudo").style.marginLeft = "0px";
      document.getElementById("footer").style.width = "0px";
      document.getElementById("content").style.display = "none";
      this.hide = true
    },

    eventExibeMenu(exibe, menu) {
      this.exibeMenu = exibe;
      this.menu.map(item => {
        if (menu != "") {
          if (menu.routerName != item.routerName && menu.submenu.length > 0) {
            item.exibeSub = false;
          }
        } else {
          item.exibeSub = false;
        }

        return item;
      });
    }
  }
};
</script>

<style lang="scss">
// .btn-color {
//   color: silver !important;
//   background: #31343E;
// }

// .btn-color:hover {
//   background: #31343E;
// }

// .menu-mobile {
//   font-size: 1.4em;
//   width: 100%;
//   position: fixed;
//   z-index: 3;
//   padding: 10px 15px;
//   color: $fontColorMenu;
//   background: #31343E;
//   box-shadow: 0px 0px 10px $shadowMenu;
// }

// .fechar-modal-mobile {
//   position: absolute;
//   right: 18px;
//   top: -15px;
//   background: $menuSelecionado !important;
// }

// .foto-perfil {
//   display: inline-block;
//   font-size: 2em;
//   width: 3em;
//   height: 3em;
//   line-height: 2.4em;
//   text-align: center;
//   border-radius: 50%;
//   vertical-align: middle;
//   margin-right: 0em;
//   border: 2px solid silver;
// }

.icon-followair {
  margin-right: 0.4em;
  width: 1.3em;
  margin-top: -1px;
  fill: black !important;
}

.foto-menu-aberto {
  display: inline-block;
  font-size: 2em;
  width: 2.4em;
  height: 2.4em;
  line-height: 2.4em;
  text-align: center;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 0em;
  border: 2px solid #31343E;
}

a,
a:hover,
a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

.close {
  cursor: pointer;
}

.wrapper {
  display: flex;
  align-items: stretch;
  height: 100vh;

  .sidebar-mobile {
    min-width: 21em;
    position: fixed;
    z-index: 10;
    height: 100vh;
  }

  #conteudo {
    margin-left: $widthBar;
  }

  .conteudo-mobile {
    margin-left: 0 !important;
  }

  .margin-mobile {
    position: fixed;
    animation-name: margin-mobile;
    animation-duration: 0.8s;
    // margin-left: 21em !important;

    @keyframes margin-mobile {
      from {
        margin-left: 0em;
      }

      to {
        margin-left: 21em !important;
      }
    }

    .menu-mobile {
      color: $backgroundMenu !important;
      animation-name: color-mobile;
      animation-duration: 1s;

      @keyframes color-mobile {
        0% {
          color: $fontColorMenu;
        }

        100% {
          color: $backgroundMenu;
        }
      }
    }
  }

  .sidebar {
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: hidden;
    position: fixed;

    box-shadow: 0px 0px 10px $shadowMenu;
    background: var(--color-background);
    color: var(--color-dark);
    height: 100vh;
    width: $widthBar;

    .fixed-position {
      position: fixed;
      width: $widthBar;
    }

    .sidebar-header {
      background: var(--color-background);
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 1.4rem;
    }

    .sidebar-header .logo {
      display: flex;
      gap: 0.8rem;
      background: var(--color-background);
    }

    .sidebar-header .logo img {
      width: 100%;
      height: 100%;
      margin-left: 0px;
    }

    .sidebar-header .logo h2 {
      margin-left: 5px;
      margin-top: 9px;
      font-size: 1.4rem;
    }

    .close {
      background: var(--color-background);
    }

    .danger {
      color: red;
    }

    .footer {
      bottom: 4px;
      position: fixed;
      width: 13.4rem;

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;

        .image {
          width: 10vw;
        }

        .version {
          font-size: 0.6rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/menu/main.vue